import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../components/modal/components/modal-restricted/withRestrictedModal';
import { PopoverFactoryRenderer } from '../../../components/popovers/PopoverFactoryRenderer';
import { DecisionSeparator } from '../../components/decision-separator/DecisionSeparator';
import { UserContextType } from '../../../user/user.types';
import styles from './decisions_references.module.scss';
import {
  DecisionsLegislationSnippetContainer,
  DecisionsLegislationSnippetTitle,
  DecisionsLegislationSnippetList,
  DecisionsLegislationSnippetLink,
} from '../components/DecisionsLegislationSnippetComponents';
import { LegislationSnippetDecisionPopover } from '../popover/LegislationSnippetDecisionPopover';

type Props = {
  source: string;
  accessPremium: UserContextType['accessPremium'];
  decisions: Array<{
    url: string;
    title: string;
    referenceCitation: string;
    numberOfComments: number;
    referenceUrl?: string;
    sommaireAnaHtml?: string;
    docId: string;
  }>;
} & WithRestrictedModalProps;

export const RawDecisionReferences: FC<Props> = ({
  source,
  openRestrictedModal,
  decisions,
  accessPremium,
}) => {
  const onClick = () => {
    openRestrictedModal(source);
  };

  const displayPopover = (element: HTMLElement) => {
    const indexString = element.getAttribute('data-decision');
    if (indexString) {
      const index = parseInt(indexString, 10);
      return (
        <LegislationSnippetDecisionPopover
          source="decision-references_popover"
          decision={decisions[index]}
        />
      );
    }
  };

  return (
    <DecisionsLegislationSnippetContainer>
      <DecisionsLegislationSnippetTitle>
        <FormattedMessage
          id="decision/references/DecisionReferences.tsx/1"
          values={{ count: decisions.length }}
        />
      </DecisionsLegislationSnippetTitle>
      <PopoverFactoryRenderer renderTemplate={displayPopover}>
        <DecisionsLegislationSnippetList>
          {decisions.map((decision, index) => (
            <li key={decision.url}>
              <DecisionsLegislationSnippetLink
                index={index}
                url={decision.url}
                source={source}
                onClick={onClick}
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: decision.referenceCitation,
                  }}
                />
              </DecisionsLegislationSnippetLink>
              {accessPremium && decision.numberOfComments > 0 && (
                <>
                  <DecisionSeparator />
                  <span className={styles.refComments}>
                    <FormattedMessage
                      id="decision/references/DecisionReferences.tsx/3"
                      values={{ count: decision.numberOfComments }}
                    />
                  </span>
                </>
              )}
            </li>
          ))}
        </DecisionsLegislationSnippetList>
      </PopoverFactoryRenderer>
    </DecisionsLegislationSnippetContainer>
  );
};

export const DecisionReferences = withRestrictedModal(RawDecisionReferences);
